import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { AnalyticsSchema } from "../../fragments/Analytics";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
export const TabFieldLinkSchema = z.object({
    title: z.string().optional(),
    url: z.string(),
    accessibilityText: z.string().optional(),
    analytics: AnalyticsSchema.optional(),
});
export const TabFieldSchema = z.object({
    heading: z.string(),
    value: z.string(),
    link: TabFieldLinkSchema.optional(),
    type: z.union([z.literal("long"), z.literal("short")]).optional(),
});
export const TabGroupSchema = z.object({
    heading: z.string(),
    subheading: z.string().optional(),
    fields: z.array(TabFieldSchema),
});
export const TabSchema = z.object({
    heading: z.string(),
    id: z.string(),
    groups: z.array(TabGroupSchema),
});
const GameSpecsBladeTypeValues = ["gameSpecs"];
export const GameSpecsBladeTypesSchema = z.enum(GameSpecsBladeTypeValues);
export const GameSpecsBladeTypes = GameSpecsBladeTypesSchema.enum;
export const GameSpecsBladeSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    tabs: z.array(TabSchema),
});
export const GameSpecsBladesContractSchema = GameSpecsBladeSchema.extend({
    type: GameSpecsBladeTypesSchema,
});
export const GameSpecsContractSchema = GameSpecsBladesContractSchema.extend({
    type: z.literal(GameSpecsBladeTypes.gameSpecs),
});
//# sourceMappingURL=index.js.map